import { heroStats } from '@/mocks/home';

export default function Hero() {
  const handleNavClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden pt-[72px]"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-900/95 via-primary-800/90 to-accent-900/85"></div>
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-10 left-10 w-64 h-64 rounded-full bg-accent-500/30 blur-3xl"></div>
        <div className="absolute bottom-20 right-20 w-80 h-80 rounded-full bg-primary-500/20 blur-3xl"></div>
        <div className="absolute top-1/3 right-1/3 w-48 h-48 rounded-full bg-accent-400/25 blur-3xl"></div>
      </div>

      <div className="relative w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-8 lg:gap-16">
          <div className="flex-1 text-center lg:text-left w-full">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/15 backdrop-blur-sm border border-white/20 mb-5">
              <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulse"></span>
              <span className="text-xs md:text-sm font-medium text-white/90 whitespace-nowrap">实时更新中 · 最新入口已同步</span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-black text-white leading-tight">
              51黑料吃瓜网
              <span className="block text-accent-300 text-xl md:text-2xl lg:text-3xl mt-2 font-bold">
                你的随身吃瓜神器
              </span>
            </h1>

            <p className="text-accent-100/80 text-base md:text-lg mt-1 font-medium">
              最新 · 最全 · 最深度 —— 娱乐圈一手资讯尽在掌握
            </p>

            <p className="mt-5 text-sm md:text-base text-white/70 leading-relaxed max-w-xl mx-auto lg:mx-0">
              51黑料吃瓜网是国内领先的娱乐资讯聚合平台，7x24小时追踪娱乐圈大小事件。从明星恋情到影视爆料，从综艺幕后到网红动态，海量原创内容每日更新超过200条。支持51吃瓜轻量版APP一键下载安装，安卓用户随时随地打开就能吃瓜，最新入口同步更新永不迷路。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mt-5">
              {heroStats.map((stat) => (
                <div key={stat.label} className="flex items-center gap-2">
                  <span className="text-xl md:text-2xl font-black text-accent-300">{stat.value}</span>
                  <span className="text-xs md:text-sm text-white/50">{stat.label}</span>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mt-6">
              <a
                href="#app"
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick('#app');
                }}
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-accent-500 hover:bg-accent-400 text-white font-bold text-sm transition-all whitespace-nowrap"
              >
                <i className="ri-download-line text-lg"></i>
                立即下载51吃瓜APP
              </a>
              <a
                href="#updates"
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick('#updates');
                }}
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-white/15 hover:bg-white/25 backdrop-blur-sm border border-white/25 text-white font-medium text-sm transition-all whitespace-nowrap"
              >
                <i className="ri-newspaper-line text-lg"></i>
                开始吃瓜
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-lg">
            <div className="relative">
              <div className="absolute -inset-4 bg-gradient-to-r from-primary-400/20 to-accent-400/20 rounded-3xl blur-xl"></div>
              <img
                src="https://readdy.ai/api/search-image?query=A%20vibrant%20entertainment%20news%20portal%20interface%20mockup%20floating%20in%20dark%20space%2C%20bold%20red%20and%20orange%20accent%20colors%2C%20dynamic%20content%20cards%20showing%20celebrity%20news%20headlines%20in%20Chinese%2C%20modern%20web%20design%20aesthetic%2C%20clean%20layout%20with%20high%20visual%20impact%2C%20floating%20UI%20elements%2C%20glowing%20warm%20highlights%2C%20trending%20topic%20badges%2C%20editorial%20style&width=600&height=500&seq=hero-main-visual&orientation=landscape"
                alt="51黑料吃瓜网 - 娱乐资讯平台界面预览"
                className="relative w-full h-auto rounded-2xl"
                width="600"
                height="500"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}